import React from 'react';

const DataTable = ({ 
  columns, 
  data, 
  loading = false, 
  emptyMessage = 'No data available',
  onRowClick,
  className = '',
  ...props 
}) => {
  if (loading) {
    return (
      <div className={`data-table loading ${className}`} {...props}>
        <div className="data-table-header">
          {columns.map((col, index) => (
            <div key={index} className="data-table-cell skeleton"></div>
          ))}
        </div>
        {[...Array(5)].map((_, rowIndex) => (
          <div key={rowIndex} className="data-table-row">
            {columns.map((col, colIndex) => (
              <div key={colIndex} className="data-table-cell skeleton"></div>
            ))}
          </div>
        ))}
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className={`data-table empty ${className}`} {...props}>
        <div className="data-table-empty">
          <p>{emptyMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`data-table ${className}`} {...props}>
      <div className="data-table-header">
        {columns.map((col, index) => (
          <div key={index} className="data-table-cell header">
            {col.header}
          </div>
        ))}
      </div>
      <div className="data-table-body">
        {data.map((row, rowIndex) => (
          <div 
            key={rowIndex} 
            className={`data-table-row ${onRowClick ? 'clickable' : ''}`}
            onClick={() => onRowClick && onRowClick(row, rowIndex)}
          >
            {columns.map((col, colIndex) => (
              <div key={colIndex} className="data-table-cell">
                {col.render ? col.render(row[col.key], row, rowIndex) : row[col.key]}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DataTable;
